// Web transfer preview mapping: known marketing screenshot originals resolve to
// their lossless WebP derivative (660px phone/console, 720px Pro theme,
// 1024px wide crops per the preview manifest); the lightbox always loads the
// original.
import { CAPTURE_BASES, PHONE_CAPTURE_KEYS } from './selectedCaptures';

const SOURCE_PREFIX = '/assets/screenshots/ios-delivery/';
const PREVIEW_PREFIX = '/assets/screenshots/web-previews/';

const PREVIEW_STEMS = new Set([
  'Dashboard/iOS - Dashboard - Map View',
  'Dashboard/iOS - Dashboard - List View',
  'Dashboard/iOS - Dashboard - Hybrid View',
  'Dashboard/iOS - Dashboard - Selected Event Card',
  'snapshots/20261004T181317Z/Events/iOS - Events - Create Event',
  'snapshots/20261004T181317Z/Hosting/iOS - Hosting - Event Roster',
  'snapshots/20261005T052529Z/Hosting/iOS - Hosting - Event Management',
  'snapshots/20261005T052529Z/Pro/iOS - Pro - App Theme',
  'snapshots/20261005T052529Z/Pro/iOS - Pro - Event Card Theme',
  'snapshots/20261005T032724Z/Garage/iOS - Garage - Garage',
  'snapshots/20261005T052529Z/Garage/iOS - Garage - Engine Specifications',
  'snapshots/20261005T052529Z/Garage/iOS - Garage - Wheel Specifications',
  'snapshots/20261006T002614Z/Sample Data/iOS - Sample Data - Profile',
  'snapshots/20261006T002614Z/Sample Data/iOS - Sample Data - Public Profile',
  'snapshots/20261006T002614Z/Sample Data/iOS - Sample Data - Public Stats',
  'snapshots/20261006T002614Z/Sample Data/iOS - Sample Data - Achievements',
  'snapshots/20261006T002614Z/Garage/iOS - Garage - Aprilia Detail',
  'snapshots/20261006T002614Z/Garage/iOS - Garage - Aprilia Engine Specifications',
  'snapshots/20261006T002614Z/Garage/iOS - Garage - Aprilia Wheel Specifications',
  'snapshots/20261006T002614Z/Event Details/iOS - Event Details - Participants',
  'snapshots/20261006T002614Z/Social/iOS - Social - Friend Profile',
  'snapshots/20261006T002614Z/Pro/iOS - Pro - Active Overview',
  'snapshots/20261006T002614Z/Pro/iOS - Pro - Five Bike Garage',
  'snapshots/20261006T002614Z/Pro/iOS - Pro - Five Bike Garage More',
  'snapshots/20261006T002614Z/Stats/iOS - Stats - Premium Analytics',
  'snapshots/20261006T064505Z/Social/iOS - Social - Friends List',
  // 20261015 selected captures — every registry key resolves to its derivative.
  ...Object.values(CAPTURE_BASES),
]);

const stemOf = (src: string): { stem: string; theme: string } | null => {
  const at = src.indexOf(SOURCE_PREFIX);
  if (at === -1) return null;
  const match = /^(.*) - (Light|Dark)\.png$/.exec(src.slice(at + SOURCE_PREFIX.length));
  return match ? { stem: match[1], theme: match[2] } : null;
};

export function getScreenshotPreview(src: string): string {
  const m = stemOf(src);
  if (!m || !PREVIEW_STEMS.has(m.stem)) return src;
  return `${PREVIEW_PREFIX}${m.stem} - ${m.theme}.webp`;
}

// srcset for the new 660px phone selections only — 396w + 660w derivatives.
// 1024 crop-source and legacy/unknown assets return undefined (no srcset).
export function getScreenshotPreviewSet(src: string): string | undefined {
  const m = stemOf(src);
  if (!m) return undefined;
  const key = (Object.keys(CAPTURE_BASES) as (keyof typeof CAPTURE_BASES)[]).find(
    (k) => CAPTURE_BASES[k] === m.stem
  );
  if (!key || !PHONE_CAPTURE_KEYS.has(key)) return undefined;
  const small = encodeURI(`${PREVIEW_PREFIX}${m.stem} - ${m.theme}-396.webp`);
  const large = encodeURI(`${PREVIEW_PREFIX}${m.stem} - ${m.theme}.webp`);
  return `${small} 396w, ${large} 660w`;
}
